<template>
    <Detail is-master />
</template>
<script>
    const Detail = () => import('./detail.vue')
    export default {
        name: "master-detail-notification-templates",
        components: {
            Detail
        }
    }
</script>
